// src/components/ui/sonner.jsx
import * as Sonner from "sonner";

export const Toaster = Sonner.Toaster;
export const toast = Sonner.toast;